<template>
  <div class="outer-box page-section border" :class="classObject">
    <div
      class="inner-box page-section"
      :class="{ squares: squares, row: row }"
      :style="{ 'justify-content': justifyContent }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue';

/*****************************************************************************
 * PROPS
 ****************************************************************************/
const props = defineProps({
  squares: {
    type: Boolean,
    default: false,
  },
  cssClass: {
    type: String,
    default: '',
  },
  row: {
    type: Boolean,
    default: true,
  },
  justifyContent: {
    type: String,
    default: 'unset',
  },
});

/*****************************************************************************
 * SETUP
 ****************************************************************************/
const { squares, cssClass } = toRefs(props);
const classObject = computed(() => {
  return squares.value ? cssClass.value + ' squares' : cssClass.value;
});
</script>

<style lang="scss" scoped>
.inner-box {
  display: flex;
  width: 100%;
}
</style>
